/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPaginate} from './PbPaginate';

/**
 * The ServiceListLocaleLanguagesRequest model module.
 * @module model/ServiceListLocaleLanguagesRequest
 * @version version not set
 */
export class ServiceListLocaleLanguagesRequest {
  /**
   * Constructs a new <code>ServiceListLocaleLanguagesRequest</code>.
   * @alias module:model/ServiceListLocaleLanguagesRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceListLocaleLanguagesRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceListLocaleLanguagesRequest} obj Optional instance to populate.
   * @return {module:model/ServiceListLocaleLanguagesRequest} The populated <code>ServiceListLocaleLanguagesRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceListLocaleLanguagesRequest();
      if (data.hasOwnProperty('query'))
        obj.query = ApiClient.convertToType(data['query'], 'String');
      if (data.hasOwnProperty('paginate'))
        obj.paginate = PbPaginate.constructFromObject(data['paginate']);
    }
    return obj;
  }
}

/**
 * @member {String} query
 */
ServiceListLocaleLanguagesRequest.prototype.query = undefined;

/**
 * @member {module:model/PbPaginate} paginate
 */
ServiceListLocaleLanguagesRequest.prototype.paginate = undefined;


